import { render } from "./MossTableView.vue?vue&type=template&id=3cb8ae79"
import script from "./MossTableView.vue?vue&type=script&lang=js"
export * from "./MossTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__